// TODO [DASH-8441]: Remove this normalizer once consumers use ConsolidatedPractice fields directly.

/**
 * Normalizes context.practice to a shape convertGqlToIPractice can handle,
 * regardless of whether backend returned UnifiedPractice or ConsolidatedPractice.
 * Single place to update when backend context shape changes.
 */
export const normalizeContextPractice = (practice: Record<string, any>): Record<string, any> => {
	if (!practice || !isConsolidatedPracticeShape(practice)) return practice

	return {
		...practice,
		stripeAccountId: practice.paymentId ?? null,
		vetClinicId: practice.lendingId ?? null
	}
}

const isConsolidatedPracticeShape = (practice: Record<string, any>): boolean =>
	typeof practice.id === 'string' && practice.id.startsWith('prc_')
